import {AxiosResponse} from 'axios';
import {saveAs} from 'file-saver';

const downloadAssets = async (response: AxiosResponse, fileName: string) => {
  const blob = new Blob([response.data], {
    type: response.headers['content-type'],
  });
  saveAs(blob, fileName);
};

export default downloadAssets;
